/** @typedef {import('../entities/Audit.types').AuditVerdict} AuditVerdict */
/** @typedef {import('../entities/AuditTask.types').AuditTaskStatus} AuditTaskStatus */
/** @typedef {import('../entities/Audit.types').AuditFeedbackStance} AuditFeedbackStance */

/** @type {Record<string, AuditVerdict>} */
export const VERDICTS = {
  PASS: 'pass',
  FLAG: 'flag',
  FAIL: 'fail',
};

/**
 * Options for displaying audit verdicts in the UI, including localization keys and icons.
 * @type {Array<{ value: AuditVerdict, labelKey: string, icon: string }>}
 */
export const VERDICT_OPTIONS = [
  { value: VERDICTS.PASS, labelKey: 'noteAuditor.verdictOptions.pass', icon: 'lightbulb' },
  { value: VERDICTS.FLAG, labelKey: 'noteAuditor.verdictOptions.flag', icon: 'flag' },
  { value: VERDICTS.FAIL, labelKey: 'noteAuditor.verdictOptions.fail', icon: 'priority_high' },
];

/** @type {Record<string, AuditTaskStatus>} */
export const TASK_STATUSES = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

/** @type {Record<string, AuditFeedbackStance>} */
export const FEEDBACK_STANCES = {
  ACCURATE: 'accurate',
  INACCURATE: 'inaccurate',
};
